// extracted by mini-css-extract-plugin
export default {"iframeWrap":"SpectoCalendar_iframeWrap__yDblB","linksContainer":"SpectoCalendar_linksContainer__4uFNx"};